"use strict";

exports.__esModule = true;
exports.ToggleSwitchWrapper = exports.SwitchLabel = exports.StyledToggleSwitch = exports.ScreenReaderLabel = exports.Label = exports.Input = exports.InnerLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ToggleSwitchWrapper = _styledComponents.default.div`
    position: absolute;
    width: 75px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select: none;
    padding: 0;
`;
exports.ToggleSwitchWrapper = ToggleSwitchWrapper;
const Label = _styledComponents.default.label`
    position: relative;
    display: block;
    overflow: hidden;
    border: 2px solid ${({
  theme
}) => theme.colors.toggleSwitch.border};
    border-radius: 20px;
    font-size: 0;
    margin: 0;
    cursor: pointer;
`;
exports.Label = Label;
const InnerLabel = _styledComponents.default.span`
    display: block;
    width: 200%;
    margin-left: -100%;
    transition: margin 0.2s ease-in 0s;

    &:before,
    &:after {
        display: block;
        float: left;
        width: 50%;
        height: 30px;
        padding: 0;
        line-height: 30px;
        font-size: 14px;
        font-weight: ${props => props.theme.fontWeights.regular};
        box-sizing: border-box;
    }

    &:before {
        content: "On";
        padding-left: 10px;
        color: ${({
  theme
}) => theme.colors.toggleSwitch.checked.text};
        background-color: ${({
  theme
}) => theme.colors.toggleSwitch.checked.background};
        text-align: left;
    }

    &:after {
        content: "Off";
        padding-right: 10px;
        color: ${({
  theme
}) => theme.colors.toggleSwitch.unchecked.text};
        background-color: ${({
  theme
}) => theme.colors.toggleSwitch.unchecked.background};
        text-align: right;
    }
`;
exports.InnerLabel = InnerLabel;
const SwitchLabel = _styledComponents.default.span`
    display: block;
    width: 26px;
    height: 26px;
    margin: 3px;
    background: ${({
  theme
}) => theme.colors.toggleSwitch.switch};
    position: absolute;
    top: -1px;
    bottom: 0;
    right: 40px;
    border-radius: 50%;
    transition: all 0.2s ease-in 0s;
`;
exports.SwitchLabel = SwitchLabel;
const ScreenReaderLabel = _styledComponents.default.span`
    border: 0;
	clip: rect(1px, 1px, 1px, 1px);
	clip-path: inset(50%);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
	white-space: nowrap;
`;
exports.ScreenReaderLabel = ScreenReaderLabel;
const Input = _styledComponents.default.input`
    display: none;

    &:checked + ${Label} ${InnerLabel} {
        margin-left: 0;
    }

    &:checked + ${Label} ${SwitchLabel} {
        right: 0;
    }

    &[disabled] + ${Label} {
        border-color: ${props => props.theme.colors.background2};
        cursor: not-allowed;

        ${InnerLabel} {
            &:before,
            &:after {
                background-color: transparent;
                content: "";
            }
        }

        ${SwitchLabel} {
            background-color: ${props => props.theme.colors.background2};
        }
    }
`;
exports.Input = Input;
const StyledToggleSwitch = (0, _styledComponents.default)(({
  loading,
  contrast,
  selectedLabel,
  unSelectedLabel,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", { ...otherProps
}))`
    display: inline-block;
    min-width: 75px;
    height: 34px;
    align-items: center;

    ${props => props.contrast && (0, _styledComponents.css)`
        ${Input} {
            &[disabled] + ${Label} {
                border-color: ${props => props.theme.colors.background1};

                ${SwitchLabel} {
                    background-color: ${props => props.theme.colors.background1};
                }
            }
        }
    `}

    ${props => props.loading && (0, _styledComponents.css)`
        ${Label} {
            border-color: ${props => props.contrast ? props.theme.colors.background1 : props.theme.colors.background2};
            cursor: default;
            pointer-events: none;

            ${InnerLabel} {
                &:before {
                    content: "";
                    background-color: ${props => props.contrast ? props.theme.colors.background1 : props.theme.colors.background2};
                }
                &:after {
                    content: "";
                }
            }

            ${SwitchLabel} {
                background-color: ${props => props.contrast ? props.theme.colors.background1 : props.theme.colors.background2};
            }
        }

        input:checked + ${Label} ${SwitchLabel} {
            right: 40px !important;
        }

        input + ${Label} ${InnerLabel} {
            &:before {
                display: none;
            }
        }
    `}

    ${props => props.selectedLabel && (0, _styledComponents.css)`
        ${Label} {
            ${InnerLabel} {
                &:before {
                    content: "${props => props.selectedLabel}";
                }
            }
        }
    `}

    ${props => props.unSelectedLabel && (0, _styledComponents.css)`
        ${Label} {
            ${InnerLabel} {
                &:after {
                    content: "${props => props.unSelectedLabel}";
                }
            }
        }
    `}
`;
exports.StyledToggleSwitch = StyledToggleSwitch;